import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface FavoriteChangeEvent {
    programId: string;
    isFavorite: boolean;
}

@Injectable({
    providedIn: 'root'
})
export class FavoritesSyncService {
    private favoriteChangeSubject = new Subject<FavoriteChangeEvent>();
    
    // Observable that components can subscribe to
    favoriteChange$ = this.favoriteChangeSubject.asObservable();

    /**
     * Emit a favorite change event to all subscribers
     * @param programId - The ID of the program that was favorited/unfavorited
     * @param isFavorite - The new favorite status
     */
    emitFavoriteChange(programId: string, isFavorite: boolean): void {
        this.favoriteChangeSubject.next({ programId, isFavorite });
    }
}
